export default "__VITE_ASSET__DQJ09goY__"